import useLocalStore from '../../../hooks/useLocalStore';
import FJHeaderPanel from './FJHeaderPanel';
import FJHeaderConfig from '../../../config/FJHeaderConfig';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import { LOCAL } from '../../../constants/FJEvnConstant';
const environment = import.meta.env.MODE;
const isLocal = environment === LOCAL;

const FJHeaderContainer = () => {
    useLocalStore();

    const curLag = FJLocalStore.currentTag();
    const _getHref = useCallback(
        href => {
            return isLocal ? href.replace('/apply', '') : `/${curLag}${href}`;
        },
        [curLag],
    );
    const headerDropDownData = useMemo(() => {
        return FJHeaderConfig.aiMenuList.map(item => ({
            title: item.title,
            href: _getHref(item.href),
            icon: item.icon,
        }));
    }, [_getHref]);

    return <FJHeaderPanel headerDropDownData={headerDropDownData} />;
};

export default FJHeaderContainer;
